export default __webpack_public_path__ + "bg_night.ee7e065.svg";